import { render } from "./FIBO.vue?vue&type=template&id=5d171823&scoped=true"
import script from "./FIBO.vue?vue&type=script&lang=js"
export * from "./FIBO.vue?vue&type=script&lang=js"

import "./FIBO.vue?vue&type=style&index=0&id=5d171823&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d171823"]])

export default __exports__